export function getFullPhoneNumber(phoneNumberObj: PhoneNumberModel) {
  return phoneNumberObj?.e164Number || null
}

export function getPhoneNumberCountry(phoneNumberObj: PhoneNumberModel) {
  return phoneNumberObj?.countryCode || null
}


export class PhoneNumberModel {
  number: string;
  internationalNumber: string;
  nationalNumber: string;
  e164Number: string;
  countryCode: string;
  dialCode: string;
}
